export default __webpack_public_path__ + "a43b62c091b2dc0c24e88a1959848fce.svg";